<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <Detail
      v-if="accidentItem"
      class="dialog"
      :class="{ xs: $vuetify.breakpoint.xsOnly }"
      :accident="accidentItem"
      :history_nearby="historyItem"
    />
    <router-view></router-view>
  </v-container>
</template>

<script>
import Detail from '../components/report/Detail.vue';

export default {
  name: 'Report',
  components: {
    Detail
  },
  // props: ['data'],
  data: () => ({
    id: null,
    accidentItem: null,
    historyItem: null
  }),
  created() {
    this.id = this.$route.query.data;
    // const accident = this.$cookies.get(`acc-${this.id}`);
    // if (accident) {
    //   this.accidentItem = accident;
    // } else {
    this.getReportData();
    this.getHistoryData();
    // }
  },
  beforeDestroy() {
    // alert(this.id);
    // console.log(this.id);
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.id = this.$route.query.data;
    },
    gotoPage(page) {
      this.$router.push({ name: page });
    },
    getReportData() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/accident/${this.id}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200) {
            scope.accidentItem = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentItem = {};
          const { response } = error;
          if (response.status === 401) {
            scope.gotoPage('unauthorized');
          }
        });
    },
    getHistoryData() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/accident/history_nearby/${this.id}`;

      this.axios
        .get(url, { params: { lazy: true } })
        .then(response => {
          if (response.status === 200) {
            scope.historyItem = response.data.data;
          }
        })
        .catch(function(error) {
          scope.historyItem = [];
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
